// pages/Login/styles.js
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export const LoginWrapper = styled.div`
  min-height: calc(100vh);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${props => props.theme.spacing.xl};
  background: ${props => props.theme.colors.background.alt};
`;

export const LoginCard = styled(motion.div)`
  background: ${props => props.theme.colors.background.main};
  border-radius: ${props => props.theme.borderRadius.lg};
  box-shadow: ${props => props.theme.shadows.lg};
  padding: ${props => props.theme.spacing.xxl};
  width: 100%;
  max-width: 400px;
`;

export const Logo = styled.div`
  text-align: center;
  margin-bottom: ${props => props.theme.spacing.xl};
  
  h1 {
    font-size: ${props => props.theme.typography.sizes['2xl']};
    font-weight: ${props => props.theme.typography.weights.bold};
    color: ${props => props.theme.colors.primary.main};
  }
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.lg};
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.xs};
`;

export const Label = styled.label`
  font-size: ${props => props.theme.typography.sizes.sm};
  font-weight: ${props => props.theme.typography.weights.medium};
  color: ${props => props.theme.colors.text.primary};
`;

export const Input = styled.input`
  padding: ${props => props.theme.spacing.md};
  border: 1px solid ${props => props.theme.colors.text.disabled};
  border-radius: ${props => props.theme.borderRadius.md};
  font-size: ${props => props.theme.typography.sizes.md};
  transition: all ${props => props.theme.transitions.fast};

  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.primary.main};
    box-shadow: 0 0 0 2px ${props => props.theme.colors.primary.main}20;
  }
`;

export const ErrorMessage = styled.div`
  color: ${props => props.theme.colors.error.main};
  font-size: ${props => props.theme.typography.sizes.sm};
  margin-top: ${props => props.theme.spacing.xs};
`;

export const ForgotPassword = styled(Link)`
  font-size: ${props => props.theme.typography.sizes.sm};
  color: ${props => props.theme.colors.primary.main};
  text-align: right;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const RegisterLink = styled.div`
  text-align: center;
  margin-top: ${props => props.theme.spacing.xl};
  font-size: ${props => props.theme.typography.sizes.sm};
  color: ${props => props.theme.colors.text.secondary};

  a {
    color: ${props => props.theme.colors.primary.main};
    text-decoration: none;
    font-weight: ${props => props.theme.typography.weights.medium};

    &:hover {
      text-decoration: underline;
    }
  }
`;